import { Outlet, useLoaderData } from "@remix-run/react";
import Footer from "../components/Footer";
import Header from "../components/header";
import { getUser } from "../lib/database_interfaces/user";
import { getSupabaseWithSessionHeaders } from "../lib/supabase_server";
import { json } from "@remix-run/node";
import { type LoaderFunctionArgs } from "@remix-run/node";

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const { headers, session, supabase } = await getSupabaseWithSessionHeaders({
    request,
  });

  if (session?.user?.id) {
  const user = await getUser({ userId: session.user.id, dbClient: supabase });
  return json({ userDetails: { ...user } }, { headers });
  }

  return json({ userDetails: null }, { headers });
};

export default function ProductRoute() {
  const { userDetails } = useLoaderData<typeof loader>();
  return (
    <div className="flex flex-col min-h-screen">
      <Header
        userId={userDetails?.id || ""}
        userName={userDetails?.first_name || ""}
        isAdmin={Boolean(userDetails?.admin)}
      />
      <Outlet />
      <Footer />
    </div>
  );
}
